const { isEmpty } = _uo.utility;

/**
 * Finds a loop filter inside a loop
 *
 * @param {Number} loopID The loop ID
 * @param {Number} loopFilterID The loop filter ID
 * @return {Object} The loop filter
 */
const getLoopFilter = ( loopID, loopFilterID ) => {
	// Get the loop
	const loop = UncannyAutomator._core.recipe.item.loop.getLoop( loopID );

	// If the item is not define, stop here
	if ( isEmpty( loop ) ) {
		throw new Error( `getLoopFilter: The loop ${ loopID } doesn't exist` );
	}

	return loop.filters.find( loopFilter => loopFilter.id === loopFilterID );
}

export default getLoopFilter;
